import { useDispatch } from 'react-redux'
import { useProductReturnExchangeGuideQuery } from '@/graphql/generated/hooks'
import { doSetGlobalToastContent } from '@/stores/reduxUI'
import { ApiErrorUtils } from '@/utils/utilApiErrors'

interface UseExchangeRefundGuideQueryProps {
  productId: string
}

export const useExchangeRefundGuideQuery = ({ productId }: UseExchangeRefundGuideQueryProps) => {
  const dispatch = useDispatch()

  try {
    const { data, error } = useProductReturnExchangeGuideQuery({
      variables: {
        id: productId,
      },
    })

    if (error) {
      // backend에서 넘어온 에러
      const errorInfo = ApiErrorUtils.getError(error)
      throw new Error(errorInfo.message)
    }

    // 성공시 data 리턴
    return {
      data: data?.product?.seller?.returnExchangeGuide || '',
    }
  } catch (error) {
    // network error
    const errorInfo = ApiErrorUtils.getError(error)
    dispatch(
      doSetGlobalToastContent({
        content: `${errorInfo.message}\n오류가 지속된다면 고객센터에 문의해 주세요`,
        duration: 5,
      })
    )
    return {
      data: '',
    }
  }
}
